import { render } from "./PropertyMarks.vue?vue&type=template&id=24a68ffa&scoped=true&ts=true"
import script from "./PropertyMarks.vue?vue&type=script&lang=ts"
export * from "./PropertyMarks.vue?vue&type=script&lang=ts"

import "./PropertyMarks.vue?vue&type=style&index=0&id=24a68ffa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a68ffa"]])

export default __exports__